// Archivo: ui/BatchDetailView.js

import React from 'react';

export default function BatchDetailView({ batch }) {
    if (!batch) return null;

    // --- Lógica para determinar el tipo de lote y configurar la vista ---
    let title = 'Detalle de Lote';
    let headers = ["Producto", "Diseño", "Talla", "Color", "Cantidad"];
    let showHeaderInfo = false;
    let headerInfo = {};

    if (batch.type === 'Producción') {
        title = 'Detalle del Lote de Producción';
        headers = ["Producto Base", "Diseño Aplicado", "Talla Prod.", "Talla Diseño", "Color", "Cant."];
        showHeaderInfo = true;
        headerInfo = {
            "Registrado por": batch.createdBy,
            "Fecha de Registro": batch.createdAtFormatted,
        };
    } else if (batch.status) { // Asumimos que si tiene 'status', es un Traslado o Salida
        if (batch.originLocationName) { // Es un Traslado
            title = 'Detalle de Lote de Traslado';
            headers = ["Producto", "Origen", "Destino", "Cant."];
        } else { // Es una Salida
            title = 'Detalle de Lote de Salida';
            headers = ["Producto", "Ubicación", "Razón", "Cant."];
        }
        
        const getStatusBadgeColor = (status) => {
            switch (status) {
                case 'aprobado': return 'bg-green-100 text-green-700';
                case 'pendiente': return 'bg-yellow-100 text-yellow-700';
                case 'rechazado': return 'bg-red-100 text-red-700';
                default: return 'bg-gray-100 text-gray-700';
            }
        };

        showHeaderInfo = true;
        headerInfo = {
            "Solicitado por": batch.requester,
            "Fecha de Solicitud": batch.createdAt,
            "Estado": <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadgeColor(batch.status)}`}>{batch.status}</span>
        };
        if (batch.status !== 'pendiente') {
            const actionText = batch.status === 'aprobado' ? 'Aprobado' : 'Rechazado';
            headerInfo[`${actionText} por`] = batch.approver || '--';
            headerInfo["Fecha de Proceso"] = batch.approvedAt || '--';
        }
    } else { // Por defecto, es un Ingreso
        title = 'Detalle del Lote de Ingreso';
        showHeaderInfo = true;
        headerInfo = {
            "Registrado por": batch.createdBy,
            "Fecha de Registro": batch.createdAtFormatted,
        };
    }
    
    const renderRowCells = (item) => {
        if (batch.type === 'Producción') {
            return (
                <>
                    <td className="p-2 font-medium">{item.productName}</td>
                    <td className="p-2">{item.designName}</td>
                    <td className="p-2">{item.size}</td>
                    <td className="p-2">{item.designSize || 'N/A'}</td>
                    <td className="p-2">{item.color}</td>
                    <td className="p-2 text-right font-bold">{item.quantity}</td>
                </>
            );
        } else if (batch.originLocationName) { // Traslado
            return (
                <>
                    <td className="p-2 font-medium">
                        <p>{item.productName} ({item.size}, {item.color})</p>
                        {item.designName !== 'Liso' && <p className="text-xs text-indigo-500">{item.designName}</p>}
                    </td>
                    <td className="p-2">{item.originLocationName}</td>
                    <td className="p-2">{item.destinationLocationName}</td>
                    <td className="p-2 text-right font-bold">{item.quantity}</td>
                </>
            );
        } else if (item.reason) { // Salida
            return (
                 <>
                    <td className="p-2 font-medium">
                        <p>{item.productName} ({item.size}, {item.color})</p>
                        {item.designName !== 'Liso' && <p className="text-xs text-indigo-500">{item.designName}</p>}
                    </td>
                    <td className="p-2">{item.locationName}</td>
                    <td className="p-2">{item.reason}</td>
                    <td className="p-2 text-right font-bold">{item.quantity}</td>
                </>
            );
        } else { // Ingreso
             return (
                <>
                    <td className="p-2 font-medium">{item.productName}</td>
                    <td className="p-2">{item.designName}</td>
                    <td className="p-2">{item.size}</td>
                    <td className="p-2">{item.color}</td>
                    <td className="p-2 text-right font-bold">{item.quantity}</td>
                </>
            );
        }
    }

    return (
        <div className="text-sm text-gray-700 space-y-4">
            <div className="p-4 bg-gray-50 rounded-lg border">
                <h3 className="font-bold text-lg text-gray-800">{title}</h3>
                <p className="font-mono text-xs text-gray-500 mt-1">{batch.batchId}</p>
                {showHeaderInfo && (
                    <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
                        {Object.entries(headerInfo).map(([key, value]) => (
                            <React.Fragment key={key}>
                                <span className="font-semibold">{key}:</span>
                                <span>{value}</span>
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </div>

            <div className="overflow-y-auto max-h-[50vh] border rounded-lg">
                <table className="w-full">
                    <thead className="bg-gray-100 sticky top-0">
                        <tr>
                            {headers.map(header => (
                                <th key={header} className={`p-2 text-left text-sm font-semibold text-gray-600 ${header.startsWith('Cant') ? 'text-right' : ''}`}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {batch.items.map((item, index) => (
                            <tr key={item.id || item.tempId || index} className="border-t">
                                {renderRowCells(item)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className="flex justify-end font-bold text-gray-800 pt-2 border-t">
                <span>Cantidad Total de Productos: {batch.totalQuantity}</span>
            </div>
        </div>
    );
}